var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 9201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.44446 6.5H20.5556L19.3333 23H4.66668L3.44446 6.5Z",
    stroke: "#A6A6A6",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.2777 8.94443L15.6666 20.5555",
    stroke: "#A6A6A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 8.94443V20.5555",
    stroke: "#A6A6A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.72217 8.94443L8.33328 20.5555",
    stroke: "#A6A6A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.8889 3.44444H20.5556C21.9056 3.44444 23 4.53886 23 5.88889V6.5H1V5.88889C1 4.53886 2.09441 3.44444 3.44444 3.44444H7.11111M16.8889 3.44444L15.6667 1H8.33333L7.11111 3.44444M16.8889 3.44444H7.11111",
    stroke: "#A6A6A6",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.c64eced60409a4cb3f7ef990db59d6da.svg";
export { ForwardRef as ReactComponent };